import React, { FC } from "react";
import { Modal, Button, TextField, Autocomplete } from "@mui/material";
import { AdminDealer } from "../dealerZone/Service/ServiceRepair/useServiceSelection";
import { styled } from "@mui/material/styles";
import useDealerSearchSelector from "./useDealerSearchSelector";

const StyledDivModal = styled("div")(({ theme }) => ({
  position: "absolute",
  width: 400,
  backgroundColor: theme.palette.background.paper,
  border: "2px solid #000",
  boxShadow: theme.shadows[5],
  padding: theme.spacing(2, 4, 3),
  textAlign: "center",
}));

interface AdminDealerSearchProps {
  open: boolean;
  handleClose: () => void;
  adminFillFields: (lbl: AdminDealer) => void;
  role?: string;
}

const AdminDealerSearch: FC<AdminDealerSearchProps> = ({
  open,
  handleClose,
  adminFillFields,
  role,
}) => {
  const { handleChange, selectedDealer, dealers, modalStyle } =
    useDealerSearchSelector();

  const body = (
    <StyledDivModal style={modalStyle}>
      {role && !role.includes("Manager") ? (
        <h3 id="simple-modal-description">Search by Dealer</h3>
      ) : (
        <h3 id="simple-modal-description">Select a Rep.</h3>
      )}

      <div style={{ padding: 20 }}>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={dealers}
          sx={{ width: 300 }}
          onChange={handleChange}
          getOptionLabel={(option: AdminDealer) =>
            `${option.dealer} - ${option.dealerRep}`
          }
          renderInput={(params) => (
            <TextField
              variant="outlined"
              {...params}
              label="Dealer/Dealer Rep"
            />
          )}
        />
      </div>

      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <Button onClick={handleClose} variant="contained" color="inherit">
          Cancel
        </Button>

        <Button
          onClick={() => adminFillFields(selectedDealer as AdminDealer)}
          size="large"
          variant="contained"
          color="primary"
        >
          Confirm
        </Button>
      </div>
    </StyledDivModal>
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      {body}
    </Modal>
  );
};

export default AdminDealerSearch;
